<form class="srp-password-setup__form"
      [formGroup]="form">
    <mat-form-field class="new-password-field"
                    [srpAsterisk]>
        <input matInput
               type="password"
               srpNoAutocomplete
               formControlName="newPassword"
               placeholder="{{passwordPalceHolder}}">
        <mat-error *ngIf="newPasswordControl.hasError('required')">
            {{passwordRequiredErrorLabel}}
        </mat-error>
        <mat-error *ngIf="newPasswordControl.hasError('password')">
            {{passwordValidationErrorLabel}}
        </mat-error>
    </mat-form-field>
    <mat-form-field class="confirm-password-field"
                    [srpAsterisk]>
        <input matInput
               [errorStateMatcher]="confirmPasswordErrorStateMatcher"
               type="password"
               srpNoAutocomplete
               formControlName="confirmNewPassword"
               placeholder="{{confirmPlaceHolder}}">
        <mat-error *ngIf="confirmNewPasswordControl.hasError('required')">
            {{confirmPasswordRequiredErrorLabel}}
        </mat-error>
        <mat-error *ngIf="form.hasError('nomatch')">
            Passwords don't match.
        </mat-error>
    </mat-form-field>
</form>